/**
 * List of main domains that should use slug-based API calls
 */
export const MAIN_DOMAINS = [
  'smarttravel-vr.mobifone.ai',
  'smarttravel-vr.mobifone.vn',
  'localhost',
];

/**
 * Check if the current domain is a custom domain (not one of the main domains)
 * Custom domains should use domain-based API calls
 * 
 * @param domain - The domain to check (e.g., window.location.hostname)
 * @returns true if it's a custom domain, false if it's a main domain
 */
export const isCustomDomain = (domain: string): boolean => {
  if (!domain) return false;
  return !MAIN_DOMAINS.some(mainDomain => domain.includes(mainDomain));
};

/**
 * Get the current domain from window.location.hostname
 * Returns empty string if running on server-side
 */
export const getCurrentDomain = (): string => {
  if (typeof window === 'undefined') return '';
  return window.location.hostname;
};

